import DsioContextFilters from '@/DsioContextFilters';
import DsioDetail from '@/DsioDetail';
import DsioEngine from '@/DsioEngine';
import DsioList from '@/DsioList';
import DsioMap from '@/DsioMap';
import DsioMods from '@/DsioMods';
import DsioPagination from '@/DsioPagination';
import DsioSort from '@/DsioSort';
import DsioUserPos from '@/DsioUserPos';
import Axios from 'axios';
import Events from 'classes/Events';
import debounce from 'lodash.debounce';

export default {
  components: {
    DsioEngine,
    DsioList,
    DsioMap,
    DsioDetail,
    DsioSort,
    DsioMods,
    DsioContextFilters,
    DsioUserPos,
    DsioPagination,
  },
  data () {
    return {
      scrollIntoView: false,
      mapPopupOpen: false,
      nbVisibleFilters: 5,
      filters: {},
      counter: '',
      sorts: [],
      sortDesc: null,
      list: {},
      pagination: null,
      // map
      mapConf: {},
      bounds: [],
      mapItems: {},
      total: {},
      loading: false,
      loadingMore: false,
      sortedIds: [],
      staticConf: {
        trads: {},
        detail: {},
      },
    };
  },
  computed: {
    defaultViewMod () {
      return this.app.params.defaultViewMod;
    },
    breakpoint () {
      return this.$root.breakpoint;
    },
    inApp () {
      return this.$root.scrollInApp;
    },
    scrollUp () {
      return this.$root.scrollUp;
    },
    oiId () {
      return this.app.state.detail.oiId;
    },
    requestParams () {
      return this.$store.getters[this.instanceId + '/requestParams'];
    },
    moreFilters () {
      return this.storeState.moreFilters;
    },
    ready () {
      return this.getter('ready');
    },
  },
  watch: {
    mapItems (mapItems) {
      Events.listChange(mapItems);
    },
    oiId (id) {
      // LEH ajout classe global pour print detail au format popup
      id === null ? this.$refs.appContainer.classList.remove('dsio-app-detail-open') : this.$refs.appContainer.classList.add('dsio-app-detail-open');
    },
    ready (isReady, wasReady) {
      if (isReady && !wasReady) { // dsio on load
        this.$nextTick(() => {
          Events.loaded();
        });
      }
    },
    mapPopupOpen (value) {
      value ? this.$refs.appContainer.classList.add('map-popup-open') : this.$refs.appContainer.classList.remove('map-popup-open');
    },
    scrollUp (value) {
      this.$refs.appContainer.classList.toggle('scrollUp');
    },
    inApp (value) {
      this.$refs.appContainer.classList.toggle('inApp');
    },
    loading (isLoading) {
      isLoading ? this.$refs.appContainer.classList.add('loading') : this.$refs.appContainer.classList.remove('loading');
      // this.$refs.appContainer.classList.toggle('loading');
    },
    breakpoint (value) {
      this.updateBreakpoints(value);
      this.watchMapUpdate();
    },
    moreFilters (val) {
      this.$refs.appContainer.classList.toggle('moreFilters');

      // ajout classe html
      // plus de filtres mobile
      if (this.isMobileScreen && this.app.state.viewMod === 'list') {
        this.setWindowOverflow(val);
      }
    },
    viewMod (mod, lastMod) {
      this.$refs.appContainer.classList.remove(lastMod);
      this.$refs.appContainer.classList.add(mod);
      this.mapPopupOpen = false;
      // ajout classe html
      // carte mobile
      this.setWindowOverflow(mod === 'mixte' && this.isMobileScreen);
    },
    requestParams (params) {
      // Si l'application est prête
      if (this.ready) {
        /**
         * on active le loader que si pagination
         * car elle remplace la liste au lieu d'ajouter
         * ou si aucun changement de page à eu lieu
         * pour les autres modes de pagination auto ou more
         */
        if (this.app.params.paginationType === 'numbers' || (this.app.params.paginationType === 'more' && this.app.state.currentPage === 1)) {
          this.loading = true;

          // mettre à jour de scroll pour haut de liste
          // si dans la liste
          // si recherche hors pagination more

          if (typeof jQuery !== 'undefined' && window.scrollY > jQuery(this.$refs.appContainer).offset().top + 100) {
            this.scrollIntoView = true;
          }
        } else {
          this.loadingMore = true;
        }

        this.$Request.replaceState(this.historyState);

        this.debouncedRequest(params);
      }
    },
  },
  /**
   * Quand le composant est créer on hydrate les données (récupère les données déjà rendu)
   */
  created () {
    this.updateBreakpoints(this.breakpoint);

    // Créer le debounce pour requestData
    this.debouncedRequest = debounce(this.requestData, 300);

    const instance = this.$root.instance;

    // Initialise les données
    this.setData(instance);

    // Initialise la carte
    if (typeof instance.filters.geo !== 'undefined') {
      const map = instance.filters.geo;
      let bounds = map.conf.bounds || null;
      if (typeof map.requestValue !== 'undefined' && map.requestValue.length === 2) {
        bounds = map.requestValue;
      }

      this.bounds = bounds;
      this.mapConf = map.conf;
    }
  },
  mounted () {
    this.watchMapUpdate();
    this.refreshBasket();
  },
  methods: {
    watchMapUpdate () {
      // affichage liste pour les petits écrans
      // au 1er chargement + resize
      const fallbackViewMod = 'list';
      if (this.app.params.viewMods.indexOf(fallbackViewMod) > -1 &&
        this.defaultViewMod === 'mixte' && this.isMobileScreen) {
        this.dispatch('updateMod', fallbackViewMod);
      }
    },
    updateBreakpoints (breakpoint) {
      if (breakpoint) {
        switch (breakpoint) {
          case 'mobile':
            this.nbVisibleFilters = 1;
            break;
          case 'tablet':
            this.nbVisibleFilters = 1;
            break;
          case 'small_desktop':
            this.nbVisibleFilters = 2;
            break;
          case 'large_desktop':
            this.nbVisibleFilters = 4;
            break;
          case 'very_large_desktop':
            this.nbVisibleFilters = 5;
            break;
        }
      }
    },
    requestData (params) {
      // Stringify l'object initialSetting pour l'envoyé en POST
      let data = 'settings=' + JSON.stringify(this.app.params);

      // Lance la requete ajax
      Axios.post(this.requestUrl + '/ajax', data, { params })
      // Si pas d'erreur mes à jour les données
        .then(({ data: instance }) => {
          // const pour ne pas transformer en objet reactive
          const EventObject = instance.eventObject ? JSON.parse(JSON.stringify(instance.eventObject)) : {};

          // On met à jour les données de l'instance
          // this.dispatch('updateInstance', instance.app);
          // stockage pour affichage finale
          // Met à jour les données des composants
          this.setData(instance);

          this.$nextTick(() => {
            Events.searchEnd(EventObject);
          });

          return undefined;
        })
        // Dans tout les cas désactive le mode chargement
        .finally(() => {
          this.loading = this.loadingMore = false;

          // on remonte en haut de liste
          if (this.scrollIntoView) {
            this.$refs.appBody.scrollIntoView();
            this.scrollIntoView = false;
          }

          // panier
          this.refreshBasket();
        })
        // Si Erreur l'affiche dans la console
        .catch(console.error.bind(console));
    },
    setData (instance) {
      // Set toutes les données
      for (let property in instance) {
        if (instance.hasOwnProperty(property) && this.hasOwnProperty(property)) {
          switch (typeof instance[property]) {
            case 'object':
              if (Array.isArray(this[property])) {
                this[property] = instance[property];
              } else {
                this[property] = Object.freeze(Object.assign({}, instance[property]));
              }
              break;
            default:
              this[property] = instance[property];
          }
        }
      }

      this.total = this.sortedIds.length;

      // Set les mapItems de la carte
      if (typeof instance.filters !== 'undefined' && typeof instance.filters.geo !== 'undefined') {
        this.mapItems = Object.freeze(Object.assign({}, instance.filters.geo.mapItems));

        // LEH evo 2020-09 full js
        const map = instance.filters.geo;
        let bounds = map.conf.bounds || null;
        if (typeof map.requestValue !== 'undefined' && map.requestValue.length === 2) {
          bounds = map.requestValue;
        }
        this.bounds = bounds;
        this.mapConf = map.conf;
      }

      // Définit les éléments de la liste et freeze l'objet pour une meilleure réactivité
      if (typeof instance.views !== 'undefined') {
        this.pagination = instance.views.pagination;

        // liste avec append ou replace selon mode
        if (this.app.params.paginationType !== 'numbers' && this.app.state.currentPage > 1) {
          this.list = Object.freeze(Object.assign({}, this.list, instance.views.list));
        } else {
          this.list = Object.freeze(Object.assign({}, instance.views.list));
        }

        this.counter = instance.views.counter;
      }

      this.sendChangeEvent();
    },
    sendChangeEvent () {
      this.$emit('change', {
        total: this.total,
      });
    },
    closeMoreFilters () {
      if (this.moreFilters) {
        this.commit('UPDATE_MORE_FILTERS', false);
      }
    },
  },
};
